import { render, staticRenderFns } from "./WelcomeCoinsItem.vue?vue&type=template&id=30bc08cc&scoped=true&"
import script from "./WelcomeCoinsItem.vue?vue&type=script&lang=ts&"
export * from "./WelcomeCoinsItem.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeCoinsItem.vue?vue&type=style&index=0&id=30bc08cc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bc08cc",
  null
  
)

export default component.exports